/* jshint esversion: 6 */
import React from 'react';
import SocialPanelModule from 'app/mixins/SocialPanelModule.js';
import { Link } from 'react-router-dom';

class SlackOptions extends React.Component {
    render() {
        let currentPanel = null,
            optionFields = null,
            visibleSettings = null,
            prefixSpace = !!parseInt(this.props.getParamValue('prefixSpace'), 10),
            postfixSpace = !!parseInt(this.props.getParamValue('postfixSpace'), 10),
            socialStats = !!parseInt(this.props.getParamValue('socialStats'), 10),
            includeSummaryTitle = !!parseInt(this.props.getParamValue('includeSummaryTitle'), 10),
            includeSummaryBody = !!parseInt(this.props.getParamValue('includeSummaryBody'), 10),
            constants = this.props.app.config.constants;
        // ,
        //     postStyles = [
        //         {value: constants.POST_SHARED, label: 'Shared Link'},
        //         {value: constants.POST_TEXT, label: 'Status Update'}
        //     ];

        if (this.props.activePanel !== 'advanced') {
            switch (parseInt(this.props.getParamValue('postStyle'), 10)) {
                // case constants.POST_TEXT:
                //     optionFields = (
                //         <div>
                //             {this.getPostTitle(postTitle)}
                //             {this.getPostBody(postBody)}
                //             {this.getPostUrl(postUrl)}
                //         </div>
                //     );
                //     break;

                case constants.POST_SHARED:
                default:
                    optionFields = (
                        <div>
                            {this.props.getIncludeSummaryTitle(includeSummaryTitle)}
                            {this.props.getIncludeSummaryBody(includeSummaryBody)}
                        </div>
                    );
                    break;
            }

            if (this.props.hasInputOverrides) {
                if (this.props.user.detail.routeViewType === this.props.app.config.constants.ROUTE_VIEW_SIMPLE) {
                    visibleSettings = this.props.generateInputOverrideLink();
                } else {
                    visibleSettings = (
                        <div>
                            {this.props.generateInputOverrideWarning()}
                            {optionFields}
                        </div>
                    )
                }
            } else {
                visibleSettings = (
                    <div>
                        {optionFields}
                    </div>
                );
            }


            currentPanel = (
                <div>
                    {visibleSettings}
                    {this.props.getPrefixText(prefixSpace)}
                    {this.props.getPostfixText(postfixSpace)}
                    {this.props.getActiveToggle()}
                    {this.props.getDeleteButton()}
                </div>
            );
        } else {
            currentPanel = (
                <div>
                    {this.props.getSocialStats(socialStats)}
                </div>
            );
        }

        return this.props.getPanelOutput(currentPanel);
    }
};

export default SocialPanelModule(SlackOptions);
